import type { ConnectedPosition } from '@angular/cdk/overlay';
import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';

import type { OverlayPosition } from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';
import type { WysiwygLink } from '@core/wysiwyg-legacy';

import { SchedulerLinksDropdownComponent } from './scheduler-links-dropdown.component';
import type { SchedulerLinksDropdownListController } from '../../../plugins/scheduler-links/types';

@Injectable()
export class SchedulerLinksDropdownService
  extends WysiwygComponentPortalService<SchedulerLinksDropdownComponent>
  implements SchedulerLinksDropdownListController, OnDestroy
{
  protected overlayConfig = {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
  };

  public open(
    position: OverlayPosition | DOMRect,
    _options: {
      preferredPositions?: ConnectedPosition[];
    },
  ) {
    const options = {
      preferredPositions: _options.preferredPositions || [],
    };
    this.close();
    this.openComponent(SchedulerLinksDropdownComponent, position, options.preferredPositions);
    const { instance, location } = this.componentRef!;
    instance.close = () => {
      this.close();
    };
    return {
      element: <HTMLElement>location.nativeElement,
      backdropClick$: this.overlayRef!.backdropClick(),
    };
  }

  public setSelectCallback(selectCb: (val: WysiwygLink) => void): void {
    if (!this.componentRef) return;
    this.componentRef.instance.select = selectCb;
  }
}
